
export const API_HOST = process.env.NODE_ENV === 'production' ? 'https://api.youzd.fr' : 'http://localhost:3001'